import {AbstractModel, JsonObject, JsonProperty, DateConverter} from 'projects/core/src/public-api';
import {CheckItemHeadTag} from 'projects/app-misc/src/app/modules/trello-misc/data/checkitem-head-tag';
import {ProjectFile} from 'projects/app-misc/src/app/modules/project-misc/data/project/project-file';
import {User} from 'projects/core/src/lib/login/data/user';

@JsonObject('model.TaskCheckItem')
export class TaskCheckItem extends AbstractModel {
  @JsonProperty(Boolean, 'ready')
  ready? = false;

  @JsonProperty(Number, 'id')
  id?: number;

  @JsonProperty(String, 'name')
  name?: string;

  @JsonProperty(Number, 'pos')
  pos?: number;

  @JsonProperty([CheckItemHeadTag], 'tags')
  tags?: CheckItemHeadTag[];

  collapsed?: boolean;

  @JsonProperty([ProjectFile], 'files')
  files?: ProjectFile[] = [];

  @JsonProperty(User, 'addedToSoBy')
  addedToSoBy?: User;

  @JsonProperty(DateConverter, 'addedToSoDate')
  addedToSoDate?: Date;

  workOrder?: boolean;

}
